// Generated by CoffeeScript 2.7.0
var Admin__UsersController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import UsersContainer from 'trunks/vue/admin/components/users/users_container.js';

import OrganizationNavigator from 'trunks/vue/admin/compositions/organizations_sidebar/organization_navigator.js';

import GenerateUserProfile from 'trunks/controllers/admin/user_profile/generate_profile.js';

export default Admin__UsersController = (function() {
  class Admin__UsersController extends Skylark.App.BaseController {
    index() {
      var users_container_el;
      this.query = this.getParams().query;
      if (this.query) {
        this.url = `/admin/users/query?name=${this.query}`;
      } else {
        this.url = "/admin/users.json";
      }
      this._generateOrganizationSidebarView('members', this.query);
      users_container_el = DomMaster.find("#js_users_container").node;
      return this._generateUserProfile((profileSchema) => {
        return new UsersContainer({
          el: users_container_el,
          propsData: {
            membersCount: this.getVars('members_count'),
            bindedMembersCount: this.getVars('binded_members_count'),
            resourceUrl: this.url,
            query: this.query,
            action: 'members',
            fieldable: {
              fields: profileSchema.fields
            },
            profileSchema: profileSchema
          }
        });
      });
    }

    suspended() {
      var suspended_users_container_el;
      this._generateOrganizationSidebarView('suspended_members');
      suspended_users_container_el = DomMaster.find("#js_suspended_users_container").node;
      return this._generateUserProfile((profileSchema) => {
        return new UsersContainer({
          el: suspended_users_container_el,
          propsData: {
            membersCount: this.getVars('members_count'),
            bindedMembersCount: this.getVars('binded_members_count'),
            resourceUrl: "/admin/users/suspended.json",
            fieldable: {
              fields: profileSchema.fields
            },
            profileSchema: profileSchema
          }
        });
      });
    }

  };

  Admin__UsersController.include(GenerateMorePopover);

  Admin__UsersController.include(OrganizationNavigator);

  Admin__UsersController.include(GenerateUserProfile);

  return Admin__UsersController;

}).call(this);
